export default __webpack_public_path__ + "static/media/product.6e290125.jpg";